import * as React from 'react';
import { gte } from '@lendi-ui/breakpoint';
import { Button } from '@lendi-ui/button';
import { Body, Heading } from '@lendi-ui/typography';
import { display } from '@lendi-ui/utils';
import { Cta } from '../../utils/schema';
import styled from 'styled-components';
import { ml, mr, mt } from '@lendi-ui/spacing';
import { eventTracking } from '../../utils';

const CtaWrapper = styled.div`
  ${display({ mobile: 'block', tablet: 'inline-flex' })}
  ${gte('tablet')`
    align-items: center;
  `}
`;

const CtaDetail = styled.div`
  display: flex;
  ${gte('tablet')`
    flex: 1;
  `}
`;

const CtaImage = styled.img`
  ${mr('sm')}
  width: auto;
  height: 6rem;
  flex: 0;
  border-radius: 6px;
`;

const CtaText = styled.div`
  flex: 1;
  align-self: center;
`;

const CtaButton = styled(Button)`
  ${mt({ mobile: 'sm', tablet: 'nil' })}
  ${ml({ mobile: 'nil', tablet: 'sm' })}
  width: 100%;
  ${gte('tablet')`
    width: auto;
    flex: 0;
    white-space: nowrap;
  `}
`;

interface ArticleCtaProps {
  cta: Cta;
  showImage?: boolean;
}
export const ArticleCta = ({ cta, showImage = false }: ArticleCtaProps) => (
  <CtaWrapper>
    <CtaDetail>
      {showImage && <CtaImage src={cta.image} />}
      <CtaText>
        <Heading size="sm" color="secondary.500">
          {cta.title}
        </Heading>
        <Body>{cta.subTitle}</Body>
      </CtaText>
    </CtaDetail>
    <CtaButton
      variant="primary"
      size="sm"
      href={cta.url}
      onClick={() => {
        eventTracking('above-fold', 'navigate', cta.buttonText);
      }}
    >
      {cta.buttonText}
    </CtaButton>
  </CtaWrapper>
);
